import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { NO_COUPON } from '@/constants/cart'
import type { ICoupon } from '~/schemas/cart/coupon'

export { NO_COUPON }

interface ICouponState {
    /**
     * Cupom escolhido pelo cliente: o da URL (`?coupon=`, gravado pelo `CouponFromUrl`) ou o último aplicado; ou
     * `NO_COUPON`. O carrinho aplica o escolhido ao abrir e o checkout o manda no `checkout/create`.
     */
    couponName: string | null
    /** Último cupom aplicado, como a API devolve. */
    couponData: ICoupon | null
    setCouponName: (couponName: string | null) => void
    setCouponData: (couponData: ICoupon | null) => void
    /** Nenhum cupom escolhido (o cliente removeu o cupom ou o da URL foi recusado): não é aplicado de novo. */
    clearCouponName: () => void
    resetStore: () => void
}

const initialState = {
    couponName: null as string | null,
    couponData: null as ICoupon | null,
}

/** Cupom escolhido, sem espaços nas pontas; `null` sem cupom ou com o marcador "Sem cupom". */
export const selectCouponName = (state: Pick<ICouponState, 'couponName'>): string | null => {
    const code = state.couponName?.trim()
    return code && code !== NO_COUPON ? code : null
}

export const useCouponStore = create<ICouponState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setCouponName: (couponName) => set({ couponName }, false, 'setCouponName'),
                setCouponData: (couponData) => set({ couponData }, false, 'setCouponData'),
                clearCouponName: () => set({ couponName: NO_COUPON }, false, 'clearCouponName'),
                resetStore: () => set(initialState, false, 'resetStore'),
            }),
            { name: 'coupon-storage' },
        ),
        { name: 'coupon-store' },
    ),
)
